import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const SETTINGS_LIST = "settings_list";
export const UPDATE_SETTING = "update_setting";
export const INQUIRIES_LIST = "INQUIRIES_LIST";
export const DELETE_INQ = "DELETE_INQ";
export const GET_SETTING_DETAILS = "get_setting_details";
export const CLEAR_SETTING_ERRORS = "clearSettingErrors";

// mutation types
export const SET_SETTING_ERROR = "setSettingError";
export const REMOVE_SETTING_ERRORS = "removeSettingErrors";

const state = {
    errors: null
};


const actions = {
    [SETTINGS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/settings?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_SETTING_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_SETTING_ERROR, response.errors);
                });
        });
    },
    [INQUIRIES_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/inquiries?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_SETTING_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_SETTING_ERROR, response.errors);
                });
        });
    },
    [GET_SETTING_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getsettingdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_SETTING_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_SETTING_ERROR, response.errors);
                });
        });
    },
    [UPDATE_SETTING](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatesetting", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_SETTING_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_SETTING_ERROR, response.errors);
                });
        });
    },
    [DELETE_INQ](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deleteinq", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_SETTING_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_SETTING_ERROR, response.errors);
                });
        });
    },
    [CLEAR_SETTING_ERRORS](context) {
        context.commit(REMOVE_SETTING_ERRORS);
    },
};

const mutations = {
    [SET_SETTING_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_SETTING_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
